import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaLock, FaUsers, FaHeart, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaArrowRight, FaCode, FaGlobe } from 'react-icons/fa';

/* ------------------------------------------------------------------ */
/*  Navbar                                                             */
/* ------------------------------------------------------------------ */
const Navbar = () => (
  <nav className="bg-gradient-to-r from-[#8B0000] via-[#DC143C] to-[#8B0000] shadow-lg sticky top-0 z-50">
    <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
      <Link to="/" className="text-2xl font-['Noto_Sans_Devanagari'] font-bold text-[#FFD700]">विवाह आरंभ</Link>
      <div className="hidden md:flex items-center gap-6">
        <Link to="/" className="text-white/90 hover:text-[#FFD700] transition-colors text-sm font-medium">Home</Link>
        <Link to="/about" className="text-[#FFD700] text-sm font-medium">About</Link>
        <Link to="/pricing" className="text-white/90 hover:text-[#FFD700] transition-colors text-sm font-medium">Pricing</Link>
        <Link to="/login" className="text-white/90 hover:text-[#FFD700] transition-colors text-sm font-medium">Login</Link>
        <Link to="/register" className="bg-[#FFD700] text-[#8B0000] px-4 py-1.5 rounded-full text-sm font-bold hover:bg-[#FFF8DC] transition-all">
          Register
        </Link>
      </div>
    </div>
  </nav>
);

/* ------------------------------------------------------------------ */
/*  Footer                                                             */
/* ------------------------------------------------------------------ */
const Footer = () => (
  <footer className="bg-[#8B0000] text-white">
    <div className="max-w-7xl mx-auto px-6 py-10">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-xl font-['Noto_Sans_Devanagari'] font-bold text-[#FFD700] mb-3">विवाह आरंभ</h3>
          <p className="text-white/60 text-sm">Premium Hindu Vanjari Matrimonial Platform.</p>
        </div>
        <div>
          <h4 className="font-bold text-[#FFD700] mb-3 text-sm">Quick Links</h4>
          <ul className="space-y-1.5 text-sm text-white/60">
            <li><Link to="/" className="hover:text-[#FFD700] transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#FFD700] transition-colors">About</Link></li>
            <li><Link to="/pricing" className="hover:text-[#FFD700] transition-colors">Pricing</Link></li>
            <li><Link to="/register" className="hover:text-[#FFD700] transition-colors">Register</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-[#FFD700] mb-3 text-sm">Legal</h4>
          <ul className="space-y-1.5 text-sm text-white/60">
            <li><a href="#" className="hover:text-[#FFD700]">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#FFD700]">Terms of Service</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-[#FFD700] mb-3 text-sm">Contact</h4>
          <ul className="space-y-1.5 text-sm text-white/60">
            <li className="flex items-center gap-2"><FaPhoneAlt className="text-[#FFD700] text-xs" /> +91 98765 43210</li>
            <li className="flex items-center gap-2"><FaEnvelope className="text-[#FFD700] text-xs" /> info@vivaharambh.com</li>
            <li className="flex items-center gap-2"><FaMapMarkerAlt className="text-[#FFD700] text-xs" /> Pune, Maharashtra</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/20 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-white/50">
        <p>&copy; 2026 Vivah Arambh. All rights reserved.</p>
        <p>Developed by <span className="text-[#FFD700]">Lyftek Solutions</span></p>
      </div>
    </div>
  </footer>
);

/* ================================================================== */
/*  ABOUT PAGE                                                         */
/* ================================================================== */
const AboutPage = () => {
  const values = [
    {
      icon: <FaShieldAlt size={28} />,
      title: 'विश्वास',
      eng: 'Trust',
      desc: 'Every profile is carefully verified through Aadhaar and personal verification to ensure genuine connections.',
    },
    {
      icon: <FaLock size={28} />,
      title: 'गोपनीयता',
      eng: 'Privacy',
      desc: 'Your personal information stays secure with enterprise-grade privacy controls and data protection.',
    },
    {
      icon: <FaUsers size={28} />,
      title: 'समुदाय',
      eng: 'Community',
      desc: 'Built exclusively for the Hindu Vanjari community, preserving cultural values and traditions.',
    },
    {
      icon: <FaHeart size={28} />,
      title: 'परंपरा',
      eng: 'Tradition',
      desc: 'Honouring the rich heritage of Vanjari traditions while embracing modern matchmaking technology.',
    },
  ];

  return (
    <div className="min-h-screen bg-[#FFF8F0] flex flex-col">
      <Navbar />

      {/* ============================================================ */}
      {/*  Hero Section                                                 */}
      {/* ============================================================ */}
      <section className="relative py-24 px-6 bg-gradient-to-br from-[#8B0000] via-[#DC143C] to-[#8B0000] overflow-hidden">
        {/* Mandala decoration */}
        <div className="absolute inset-0 opacity-[0.05]">
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            style={{
              width: '700px',
              height: '700px',
              borderRadius: '50%',
              background: 'repeating-radial-gradient(circle at center, transparent 0px, transparent 35px, rgba(255,215,0,0.3) 36px, transparent 37px)',
              animation: 'mandalaRotate 60s linear infinite',
            }}
          />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="text-[#FFD700] text-xl mb-3 font-['Noto_Sans_Devanagari'] opacity-60">ॐ</div>
          <h1 className="text-4xl md:text-5xl font-['Noto_Sans_Devanagari'] font-bold text-[#FFD700] mb-4">
            विवाह आरंभ बद्दल
          </h1>
          <p className="text-lg text-white/80 font-['Playfair_Display'] max-w-2xl mx-auto">
            Connecting hearts within the Hindu Vanjari community with trust, tradition, and technology.
          </p>
        </div>

        {/* Bottom wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 40L80 36C160 32 320 24 480 28C640 32 800 48 960 52C1120 56 1280 48 1360 44L1440 40V80H0V40Z" fill="#FFF8F0" />
          </svg>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  Mission Statement                                            */}
      {/* ============================================================ */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="divider-ornament mb-6">
            <span className="text-[#B8860B]">✦</span>
          </div>
          <h2 className="text-3xl font-['Playfair_Display'] font-bold text-[#8B0000] mb-6">Our Mission</h2>

          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-[#FFD700]/20 mb-8">
            <p className="text-xl font-['Noto_Sans_Devanagari'] text-[#8B0000] leading-relaxed mb-6">
              "आमचे ध्येय हिंदू वंजारी समुदायातील कुटुंबांना विश्वासार्ह, सुरक्षित आणि सोयीस्कर विवाह जुळवणी प्लॅटफॉर्म प्रदान करणे आहे."
            </p>
            <p className="text-gray-600 leading-relaxed">
              Our mission is to provide families in the Hindu Vanjari community with a trustworthy, secure, and convenient
              matrimonial matchmaking platform. We believe that finding a life partner should be a joyous journey that honours
              your cultural roots while leveraging the power of modern technology.
            </p>
          </div>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  Values                                                       */}
      {/* ============================================================ */}
      <section className="py-16 px-6 bg-gradient-to-br from-[#FFF8F0] to-[#FFE4C4]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-['Playfair_Display'] font-bold text-[#8B0000] mb-3">आमची मूल्ये</h2>
            <p className="text-gray-600">Our Core Values</p>
            <div className="divider-ornament mt-4">
              <span className="text-[#B8860B]">✦</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-7 text-center shadow-md border border-[#FFD700]/20 hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
              >
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-[#DC143C] to-[#8B0000] text-white flex items-center justify-center">
                  {v.icon}
                </div>
                <h3 className="text-xl font-['Noto_Sans_Devanagari'] font-bold text-[#8B0000] mb-1">{v.title}</h3>
                <p className="text-sm text-[#B8860B] font-semibold mb-3">{v.eng}</p>
                <p className="text-gray-600 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  Our Story                                                    */}
      {/* ============================================================ */}
      <section className="py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-['Playfair_Display'] font-bold text-[#8B0000] mb-3">आमची कथा</h2>
            <p className="text-gray-600">Our Story</p>
            <div className="divider-ornament mt-4">
              <span className="text-[#B8860B]">✦</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            {/* Left: visual element */}
            <div className="relative">
              <div className="bg-gradient-to-br from-[#8B0000] to-[#DC143C] rounded-2xl p-10 text-center relative overflow-hidden">
                {/* Mandala pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] rounded-full"
                    style={{
                      background: 'repeating-radial-gradient(circle, transparent 0px, transparent 20px, rgba(255,215,0,0.3) 21px, transparent 22px)',
                    }}
                  />
                </div>
                <div className="relative z-10">
                  <div className="text-5xl mb-4">🙏</div>
                  <h3 className="text-3xl font-['Noto_Sans_Devanagari'] font-bold text-[#FFD700] mb-3">विवाह आरंभ</h3>
                  <p className="text-white/80 text-sm">Est. 2024 | Pune, Maharashtra</p>
                  <div className="mt-6 flex justify-center gap-6 text-center">
                    <div>
                      <p className="text-2xl font-bold text-[#FFD700]">10,000+</p>
                      <p className="text-xs text-white/60">Profiles</p>
                    </div>
                    <div>
                      <p className="text-2xl font-bold text-[#FFD700]">5,000+</p>
                      <p className="text-xs text-white/60">Matches</p>
                    </div>
                    <div>
                      <p className="text-2xl font-bold text-[#FFD700]">50+</p>
                      <p className="text-xs text-white/60">Cities</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: story text */}
            <div className="space-y-5">
              <p className="text-gray-700 leading-relaxed">
                Vivah Arambh was born from a simple yet powerful vision: to create a dedicated matrimonial platform
                that truly understands and serves the Hindu Vanjari community. We recognized that existing platforms
                were generic and failed to address the unique cultural, social, and traditional values that are central
                to Vanjari families.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Founded in 2024, our platform combines the warmth of traditional matchmaking with the convenience of
                modern technology. Every feature, from our community-specific filters to our rashi and gothra matching,
                has been designed with the Vanjari community in mind.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We are committed to ensuring every connection made on our platform is built on a foundation of trust,
                verified identities, and shared cultural values. Our Aadhaar-based verification system ensures that every
                profile is genuine, giving families the confidence they need in this important decision.
              </p>
              <p className="font-['Noto_Sans_Devanagari'] text-[#8B0000] font-semibold">
                "प्रत्येक कुटुंबाला विश्वासार्ह जोडीदार शोधण्यात मदत करणे हे आमचे वचन आहे."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  Team Section                                                 */}
      {/* ============================================================ */}
      <section className="py-16 px-6 bg-gradient-to-br from-[#FFF8F0] to-[#FFE4C4]">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-['Playfair_Display'] font-bold text-[#8B0000] mb-3">विकास संघ</h2>
            <p className="text-gray-600">Development Team</p>
            <div className="divider-ornament mt-4">
              <span className="text-[#B8860B]">✦</span>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-[#FFD700]/20 text-center">
            <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#8B0000] to-[#DC143C] flex items-center justify-center shadow-lg">
              <FaCode className="text-[#FFD700] text-3xl" />
            </div>
            <h3 className="text-2xl font-['Playfair_Display'] font-bold text-[#8B0000] mb-2">Lyftek Solutions</h3>
            <p className="text-[#B8860B] font-semibold mb-4">Technology Partner & Development Team</p>
            <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto mb-6">
              Vivah Arambh is proudly designed and developed by Lyftek Solutions, a technology company passionate about
              creating impactful digital products. Our team of skilled developers, designers, and product thinkers have
              poured their expertise into building a platform that is secure, beautiful, and culturally relevant.
            </p>
            <div className="flex justify-center gap-8">
              <div className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-[#FFF8F0] flex items-center justify-center">
                  <FaGlobe className="text-[#DC143C]" />
                </div>
                <p className="text-xs text-gray-500">Web & Mobile</p>
              </div>
              <div className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-[#FFF8F0] flex items-center justify-center">
                  <FaShieldAlt className="text-[#DC143C]" />
                </div>
                <p className="text-xs text-gray-500">Security First</p>
              </div>
              <div className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-[#FFF8F0] flex items-center justify-center">
                  <FaHeart className="text-[#DC143C]" />
                </div>
                <p className="text-xs text-gray-500">Made with Love</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  Contact Section                                              */}
      {/* ============================================================ */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-3xl font-['Playfair_Display'] font-bold text-[#8B0000] mb-3">संपर्क करा</h2>
            <p className="text-gray-600">Get in Touch</p>
            <div className="divider-ornament mt-4">
              <span className="text-[#B8860B]">✦</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: <FaPhoneAlt size={22} />, title: 'Phone', value: '+91 98765 43210', subtitle: 'Mon-Sat, 9am-6pm' },
              { icon: <FaEnvelope size={22} />, title: 'Email', value: 'info@vivaharambh.com', subtitle: 'We reply within 24 hours' },
              { icon: <FaMapMarkerAlt size={22} />, title: 'Office', value: 'Pune, Maharashtra', subtitle: 'India' },
            ].map((c, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 text-center shadow-md border border-[#FFD700]/20 hover:shadow-lg transition-all duration-300">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-gradient-to-br from-[#DC143C] to-[#8B0000] text-white flex items-center justify-center">
                  {c.icon}
                </div>
                <h4 className="font-semibold text-[#8B0000] mb-1">{c.title}</h4>
                <p className="text-gray-700 font-medium">{c.value}</p>
                <p className="text-xs text-gray-500 mt-1">{c.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============================================================ */}
      {/*  CTA Section                                                  */}
      {/* ============================================================ */}
      <section className="py-16 px-6 bg-gradient-to-r from-[#8B0000] via-[#DC143C] to-[#8B0000] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: 'radial-gradient(circle, rgba(255,215,0,0.5) 1px, transparent 1px)',
              backgroundSize: '40px 40px',
            }}
          />
        </div>
        <div className="max-w-3xl mx-auto text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-['Noto_Sans_Devanagari'] font-bold text-[#FFD700] mb-4">
            आजच आमच्यात सामील व्हा!
          </h2>
          <p className="text-white/80 mb-8">
            Join thousands of families who have found their perfect match through Vivah Arambh.
          </p>
          <Link
            to="/register"
            className="inline-flex items-center gap-3 bg-[#FFD700] text-[#8B0000] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#FFF8DC] transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
          >
            नोंदणी करा <FaArrowRight />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
